import { render, staticRenderFns } from "./PasswordChangeDialog.vue?vue&type=template&id=557d3ad0&scoped=true&"
import script from "./PasswordChangeDialog.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeDialog.vue?vue&type=style&index=0&id=557d3ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d3ad0",
  null
  
)

export default component.exports